export enum TipoAvisoEnum {
  INFORME_ADMINISTRADOR = 1,
	AVISO_CONFIRMACAO = 4
}

export interface TipoAviso {
  nome: string;
  valor: TipoAvisoEnum;
}